import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  notifications: null,
  error: null,
  loading: false,
  isDeleteNotificationModalOpen: false,
};

// Get Notification
const getNotificationStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getNotificationSuccess = (state: any, action: any) => {
  return updateObject(state, {
    notifications: {
      ...action.notifications,
      items: [ ...(state.notifications?.items || []), ...(action.notifications?.items || [])]
    },
    error: null,
    loading: false,
  });
};

const getNotificationFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    notifications: null,
  });
};
  
// Delete Notification
const deleteNotificationStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteNotificationSuccess = (state: any, action: any) => {
  /* Removing the deleted notification from the store */
  let newNotificationsItems = state.notifications?.items?.filter((notification: any) => {
    return notification?.id !== action.notificationId;
  }) || [];

  return updateObject(state, {
    notifications: {
      items: newNotificationsItems,
      totalSize: (state.notifications?.totalSize || 1) - 1,
    },
    error: null,
    loading: false,
  });
};

const deleteNotificationFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const notificationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_NOTIFICATION_START:
      return getNotificationStart(state, action);
    case actionTypes.GET_NOTIFICATION_SUCCESS:
      return getNotificationSuccess(state, action);
    case actionTypes.GET_NOTIFICATION_FAIL:
      return getNotificationFailed(state, action);
    case actionTypes.DELETE_NOTIFICATION_START:
      return deleteNotificationStart(state, action);
    case actionTypes.DELETE_NOTIFICATION_SUCCESS:
      return deleteNotificationSuccess(state, action);
    case actionTypes.DELETE_NOTIFICATION_FAIL:
      return deleteNotificationFailed(state, action);
    default:
      return state;
  }
};

export default notificationReducer;
